<template>
  <div>
    <div>
      <vue-toastr ref="notificationToast"></vue-toastr>
      <div class="ibox box-primary">
        <div class="ibox-title with-border"><h2 class="box-title">{{ title }}</h2></div>
        <div class="ibox-content">

          <input name="send_test_customers"
                 type="hidden"
                 id="send_test_customers"
                 class="form-control"
                 v-model="record.send_test_customers">

          <div v-if="isAdmin" class="form-group">
            <label class="control-label">Mandant</label>
            <Select2 v-model="record.client_id" :options="clients" @change="onClientChange"/>
          </div>

          <div class="form-group">
            <label class="control-label">Prospektbenennung</label>
            <input name="name" type="text" class="form-control" v-model="record.name">
          </div>

          <text-translated
            :value="record.title"
            field-path="title"
            label="Überschrift"
            :isos="resolvedIsos"
            :languages="resolvedLanguages"
            :translations="translations"
            :flag-cdn-url="flagCdnUrl"
            @input="record.title = $event"
            @translation-updated="onTranslationUpdated" />

          <div class="form-group">
            <input name="use_date"
                   type="checkbox"
                   id="use_date"
                   v-model="record.use_date">&nbsp;
            <label>Anzeigezeitraum wählen</label>
          </div>
          <div v-if="record.use_date" class="form-group">
            <h3>Anzeigezeitraum <a class="fa fa-question-circle" v-tippy="{ placement : 'right' }"
                                   content="Zeitraum, in dem der Content im Marketing-Slider angezeigt werden soll."></a>
            </h3>
            <div class="col-md-6">
              <label>Von:</label>
              <br>
              <input name="date_start"
                     type="datetime-local"
                     id="date_start"
                     class="form-control"
                     :required="record.use_date"
                     v-model="record.date_start">
            </div>
            <div class="col-md-6">
              <label>Bis:</label>
              <br>
              <input name="date_end"
                     type="datetime-local"
                     id="date_end"
                     class="form-control"
                     :required="record.use_date"
                     v-model="record.date_end">
            </div>
          </div>

          <filepond-translated
            :value="record.media_src"
            field-path="media_src"
            label="Slider Vorschaubild"
            :isos="resolvedIsos"
            :languages="resolvedLanguages"
            :media-files="mediaFiles"
            :flag-cdn-url="flagCdnUrl"
            accepted-file-types="image/jpeg, image/png, image/webp"
            :model-class="'App\\Models\\Advertisement'"
            :model-id="record.id"
            :client-id="record.client_id"
            @input="record.media_src = $event"
            @media-updated="onMediaUpdated" />

          <div class="col-md-12">
            <div v-for="(element,index) in record.pages" :key="index">
              <advertisement-page
                :index="index"
                :advertisement="record"
                :record="element"
                :isos="resolvedIsos"
                :languages="resolvedLanguages"
                :translations="translations"
                :media-files="mediaFiles"
                :flag-cdn-url="flagCdnUrl"
                @media-updated="onMediaUpdated"
                @pages-created="onPagesCreated" />
            </div>
          </div>
          <br>
          <div class="col-md-12">
            <button type="button" class="btn btn-success col-md-12" @click="addNewElement"
                    :disabled="!record.title">
              <i class="fa fa-plus"></i> Neues Medium hinzufügen
            </button>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="form-group">
            <label>Testkundennummern <a class="fa fa-question-circle" v-tippy="{ placement : 'right' }"
                                        content="Durch Kommata getrennt, sichtbar ab App 4.3"></a></label>
            <br>
            <input name="test_customers"
                   type="text"
                   id="test_customers"
                   class="form-control"
                   v-model="record.test_customers">
          </div>

          <button type="button" class="btn btn-secondary" @click="submit"
                  :disabled="!record.title || submitting">Speichern und schließen
          </button>
          <button type="button" class="btn btn-secondary" @click="submitAndSendCampaignCustomers"
                  :disabled="!record.title || submitting">Speichern und an Testkundennummern aussenden
          </button>
          <spinner v-if="submitting"></spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import VueToastr from "vue-toastr";
import Spinner from "../common/spinner/Spinner";
import AdvertisementPage from "./AdvertisementPage.vue";
import TextTranslated from "../common/fields/TextTranslated";
import FilepondTranslated from "../common/fields/FilepondTranslated";
import translateable from "../common/fields/mixins/translateable";
import { saveTranslations as apiSaveTranslations, loadTranslations as apiLoadTranslations } from "../common/fields/services/translationApi";

export default {
  name: 'AdvertisementForm',
  mixins: [translateable],
  components: {
    AdvertisementPage,
    Spinner,
    Modal,
    VueToastr,
    TextTranslated,
    FilepondTranslated,
  },
  methods: {
    onTranslationUpdated({ fieldPath, iso, value }) {
      this.setTranslation(fieldPath, iso, value)
    },
    onMediaUpdated({ fieldPath, iso, url }) {
      this.setMediaUrl(fieldPath, iso, url)
    },
    onClientChange() {
      this.fetchClientIsos(this.record.client_id)
    },
    async loadAllTranslations() {
      if (!this.isMultiLang || !this.record.id) return
      await this.loadTranslations('App\\Models\\Advertisement', this.record.id, ['title', 'media_src'])

      for (let i = 0; i < this.record.pages.length; i++) {
        const page = this.record.pages[i]
        if (page.id) {
          const data = await apiLoadTranslations('App\\Models\\AdvertisementPage', page.id, ['media_src'])
          for (const [field, isoUrls] of Object.entries(data.media_files || {})) {
            for (const [iso, url] of Object.entries(isoUrls)) {
              this.setMediaUrl(`pages.${i}.${field}`, iso, url)
            }
          }
        }
      }
    },
    onPagesCreated(urls) {
      for (const url of urls) {
        this.record.pages.push({ media_src: url, marks: [] })
      }
    },
    addNewElement() {
      this.record.pages.push({
        marks: []
      });
      this.$forceUpdate();
      this.$parent.$forceUpdate();
    },
    async savePageTranslations(savedId) {
      const pages = this.record.pages || [];
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        if (!page.id) continue;
        const pageMedia = {};
        for (const [key, url] of Object.entries(this.mediaFiles)) {
          if (key === `pages.${i}.media_src`) {
            pageMedia['media_src'] = url;
          }
        }
        if (Object.keys(pageMedia).length > 0) {
          await apiSaveTranslations(
            'App\\Models\\AdvertisementPage',
            page.id,
            this.record.client_id,
            {},
            pageMedia,
          );
        }
      }
    },
    async submitAndSendCampaignCustomers() {
      this.record.send_test_customers = true;

      if (this.record.client_id == null) {
        return;
      }

      this.submitting = true;
      try {
        const res = await axios.patch('/backend/advertisements/' + this.record.id, this.record);
        const savedId = res.data || this.record.id;
        await this.saveTranslations('App\\Models\\Advertisement', savedId, this.record.client_id);
        await this.savePageTranslations(savedId);
        window.location = '/backend/advertisements/' + savedId + '/edit';
      } catch (e) {
        console.log(e);
      } finally {
        this.submitting = false;
      }
    },
    async submit() {
      if (this.record.client_id == null) {
        return;
      }

      this.submitting = true;
      try {
        const res = await axios.patch('/backend/advertisements/' + this.record.id, this.record);
        const savedId = res.data || this.record.id;
        await this.saveTranslations('App\\Models\\Advertisement', savedId, this.record.client_id);
        await this.savePageTranslations(savedId);
        window.location = '/backend/advertisements/';
      } catch (e) {
        console.log(e);
      } finally {
        this.submitting = false;
      }
    }
  },
  data() {
    return {
      record: null,
      submitting: false,
      files: [],
    };
  },
  props: ['clients', 'isAdmin', 'dbRecord', 'user', 'title', 'disabled'],
  async mounted() {
    this.record = this.dbRecord;
    this.record.send_test_customers = false;
    if (!Array.isArray(this.record.pages) || this.record.pages === 0) this.record.pages = [];

    await this.loadAllTranslations();
  }
}
</script>

<style scoped>
</style>
<style>
.ckeditor-wrapper .ck-content {
  min-height: 300px;
}

.filepond--root {
  font-size: 1.5rem;
}

label {
  margin-bottom: 6px;
  margin-top: 9px;
}
</style>
